wbApp.filter('leadSourceType', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_LEAD_SOURCE_FORM_RESPONSE');
            case 1:
                return $translate.instant('TXT_LEAD_SOURCE_FULL_COURSE_INTEREST');
            case 2:
                return $translate.instant('TXT_LEAD_SOURCE_PHONE');
            case 3:
                return $translate.instant('TXT_LEAD_SOURCE_EMAIL');
            case 4:
                return $translate.instant('TXT_LEAD_SOURCE_PERSONAL_CONTACT');
            case 5:
                return $translate.instant('TXT_LEAD_SOURCE_COURSE_INTEREST');
            case 6:
                return $translate.instant('TXT_LEAD_SOURCE_FORM_RESPONSE_KINDERGARTEN_ENROLLMENT');                
            default:
                return '';
        }
    };
}]);